"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGroupReservationUser = exports.isInvitedUser = exports.isExpertUser = exports.isLoginIdentityUser = void 0;
function isLoginIdentityUser(user) {
    return typeof user === 'object' && 'id' in user && 'email' in user && !('companyCode' in user);
}
exports.isLoginIdentityUser = isLoginIdentityUser;
function isExpertUser(user) {
    return typeof user === 'object' && 'id' in user && 'email' in user && 'companyCode' in user;
}
exports.isExpertUser = isExpertUser;
function isInvitedUser(user) {
    return typeof user === 'object' && 'id' in user && 'invitation' in user;
}
exports.isInvitedUser = isInvitedUser;
function isGroupReservationUser(user) {
    return typeof user === 'object' && 'id' in user && 'groupReservation' in user;
}
exports.isGroupReservationUser = isGroupReservationUser;
//# sourceMappingURL=guards.js.map